import type { Subject } from '../api/types'

/** Stable dependency key for hooks that refetch when the subject changes. */
export const subjectKey = (s: Subject) => JSON.stringify(s)

/** A pipeline card's id → the subject its notes, tasks and playbooks attach to. */
export function subjectOfLoan(loanId: string): Subject {
  return loanId.startsWith('deal:') ? { deal_id: Number(loanId.slice(5)) } : { loan_id: loanId }
}
